import React from 'react';
import { map } from 'lodash';
import FooterSocialMenu from './footerSocialMenu';

const menuItems = [ 'Phones', 'Plans', 'Deals', 'My Verizon', 'Verizon Shine', 'Contact us' ];

// Footer used by the VerizonProgress<N> concepts (BUZZ-3479).
// `children` holds the concept-specific fine print paragraphs placed before the common legal block.
const ProgressFooter = ({ receiver, children }) => (
  <div className="email-progress_footer">
    <ul className="email-progress_footer-menu">
      { map(menuItems, (item) => <li key={ item }>{ item }</li>) }
    </ul>
    <FooterSocialMenu />
    <div className="email-progress_footer-texts">
      { children }
      <p>© 2026 Verizon</p>
      <p>
        This email was sent to { receiver }. We respect your privacy. Please review our
        { ' ' }
        <span className="pseudo-link">Privacy Policy</span>. California customers can view our
        { ' ' }
        <span className="pseudo-link">California Privacy Notice</span>. You may
        { ' ' }
        <span className="pseudo-link">unsubscribe</span> from Verizon promotional emails at any time.
      </p>
      <p>Verizon, One Verizon Way, Mail Code: 180WVB, Basking Ridge, NJ 07920</p>
    </div>
  </div>
);

export default ProgressFooter;
